import moment from "moment/moment";
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(['mainConfig', 'is_authorized']),
    isLotUnsold() {
      return this.lot.status === 'unsold'
    },
    isLotSold() {
      return this.lot.status === 'sold'
    },
    isAfterSale() {
      if (!this.lot.buy_now_price || !this.isLotUnsold || this.lot.auction.status !== 'completed' || !this.lot.auction.after_sale_end_date) {
        return false;
      }
      const afterSaleEndDate =
        typeof this.lot.auction.after_sale_end_date === "string"
          ? moment(this.lot.auction.after_sale_end_date).toDate().getTime()
          : this.lot.auction.after_sale_end_date.getTime();

      return new Date().getTime() < afterSaleEndDate;
    },
    buyNowDisabled() {
      return !this.is_authorized || !this.lot.auction.is_bidder ||
        ((this.lot.winning_bid && this.lot.buy_now_price && this.lot.winning_bid.amount >= this.lot.buy_now_price) && !this.isAfterSale)
    },
    showBuyNow() {
      if (this.showEmpty) {
        return true;
      }

      if (!this.lot.buy_now_price) {
        return false;
      }

      return (this.biddingFinished && this.isAfterSale) ||
        (
          !this.biddingFinished && this.biddingStarted && this.lot.auction.type === 'timed' &&
          this.mainConfig.enableBuyNowOnPublishedAuction && ['both', 'buy_now_only'].includes(this.lot.auction.purchase_type)
        );
    }
  }
}
